import { userDetail } from '@/services/set'
export default {
  namespaced: true,
  state: {
    userInfo: null,
  },
  mutations: {
    "SET_USERINFO": (state, payload) => {
      state.userInfo = payload;
    },
  },
  actions: {
    setUserInfo(context) {
      userDetail().then(res => {
        if(res.code == 200){
          context.commit('SET_USERINFO',res.data)
        }
      })
    },
    clearUserInfo(context) {
      context.commit('SET_USERINFO',null)
    }
  },
};
